import React, {ReactElement, cloneElement, useState} from 'react';
import classnames from 'classnames';
import Icon from 'shared/components/icon';

/**
 * Similar to Card, except that it can contain media such as an image.
 */

interface Props {
  id: string;
  children: ReactElement<{hover?: boolean}>;
  onClick?: () => void;
  active?: boolean;
  errorType?: 'warning' | 'error';
  readOnly?: boolean;
}

const MediaCard = ({errorType, active, readOnly, onClick, children, id}: Props) => {
  const [hover, setHover] = useState(false);
  const isHovered = hover || !!active;

  const getClassName = () =>
    classnames(
      'portfolio-card',
      'portfolio-media-card',
      {'portfolio-card-hover': !readOnly && isHovered},
      {[`portfolio-card-${errorType}`]: errorType},
      {'portfolio-card-read-only': readOnly}
    );

  const DisplayElement = readOnly ? 'span' : 'button';

  return (
    <DisplayElement
      id={id}
      className={getClassName()}
      onMouseEnter={() => {
        setHover(true);
      }}
      onFocus={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onBlur={() => {
        setHover(false);
      }}
      onClick={onClick}
    >
      {!readOnly && isHovered && <Icon iconType="pen" className="portfolio-card-icon" />}{' '}
      {cloneElement(children, {hover: isHovered})}
    </DisplayElement>
  );
};

export default MediaCard;
